import TimeUnitToggler from "dyl-components/atoms/TimeUnitToggler";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Dropdown } from "semantic-ui-react";

export const DateRangePowerSelector = ({ label, name, onCustomSelect, isTimeUnitTogglerVersion = false }) => {
    const { control } = useFormContext();

    return (
        <Controller
            control={control}
            name={`filters[${name}]`}
            render={({ field: { name, value, onChange } }) => (
                <Dropdown
                    style={{ marginBottom: "1em" }}
                    text={label}
                    button
                    options={[
                        {
                            key: "today",
                            value: "today",
                            text: "Today",
                            content: (<>
                                {isTimeUnitTogglerVersion ? <TimeUnitToggler content='Today' active={value === 'today'} type="button" /> : "Today"}
                            </>)
                        },
                        {
                            key: "this_week",
                            value: "this_week",
                            text: "This Week",
                            content: (<>
                                {isTimeUnitTogglerVersion ? <TimeUnitToggler content='This Week' active={value === 'this_week'} type="button" /> : "This Week"}
                            </>)
                        },
                        {
                            key: "this_month",
                            value: "this_month",
                            text: "This Month",
                            content: (<>
                                {isTimeUnitTogglerVersion ? <TimeUnitToggler content='This Month' active={value === 'this_month'} type="button" /> : "This Month"}
                            </>)
                        },
                        {
                            key: "all_time",
                            value: "all_time",
                            text: "All Time",
                            content: (<>
                                {isTimeUnitTogglerVersion ? <TimeUnitToggler content='All Time' active={value === 'all_time'} type="button" /> :  "All Time"}
                            </>)
                        },
                        {
                            key: "custom",
                            value: "custom",
                            text: "Custom",
                            onClick: () => {
                                if (typeof onCustomSelect === "function") {
                                    onCustomSelect();
                                }
                            },
                            content: (<>
                                {isTimeUnitTogglerVersion ? <TimeUnitToggler content='Custom' active={value === 'custom'} type="button" /> : "Custom"}
                            </>)
                        },
                    ]}
                    selectOnBlur={false}
                    value={value}
                    onChange={(_, { value }) => {
                        onChange({ target: { name, value } });
                    }}
                />
            )}
        />
    );
};
